window.$ = window.jQuery = require('jquery');

require('./ArrayEdit');

$(".js_menu_toggle").on("click", function () {
    $(".nav_ham").toggleClass("open")
    $(".navbar_menu").toggleClass("active")
})

if ($('#js_check_with_beds')[0]) {

    // var url = "https://admin.boostmybookings.com/booking2.php?referer=ois&propid=" +
    //     '194321' + "&roomid=" + '418092' + "&checkin=" + $("#checkin").val() + "&checkout=" + $("#checkout").val() + "&br1-" + '418092' + "=Reserveer&numadult=" + $("#numAdult") + "&numchildren=" + $("#numChildren")


    var checkin = $("#start").val();
    var checkout = $("#end").val();
    var numAdult = $("#numAdult").val();
    var numChildren = $("#numChildren").val();

    setTimeout(() => {

        var roomID = $("#room_value").val();

        var roomInfo = JSON.parse($("#roomInfo").val());
        var propInfo = JSON.parse($("#propInfo").val());

        var usedRoom = roomInfo.find((element) => element.id == roomID);
        var usedProp = propInfo.find((element) => element.id == usedRoom['propID']);

        var url = "https://"+window.location.host+"/vimatapriceCheck/bedsCheck?roomID=" + usedRoom['roomID'] + "&propID=" + usedProp['propID'] +
            "&numAdult=" + numAdult + "&numChildren=" + numChildren + "&checkin=" + checkin + "&checkout=" + checkout;

        $.ajax({
            url: url,
            method: 'GET',
            type: 'json',
            success: function (response) {
                if (Math.round(response.replace(',', '.'), 2) == Math.round($('#js_check_with_beds').val(), 2)) {
                    $(".js_priceCheck_loading").addClass('hidden');
                    $(".js_priceCheck_correct").removeClass('hidden');
                    $(".js_priceCheck_text").html('Price is correct!');
                } else {
                    $(".js_priceCheck_loading").addClass('hidden');
                    $(".js_priceCheck_error").removeClass('hidden');
                    $(".js_priceCheck_text").html('Price is incorrect! Price is: €' + response);
                }
            },
            error: function (error) {
                $(".js_priceCheck_loading").addClass('hidden');
                $(".js_priceCheck_error").removeClass('hidden');
                $(".js_priceCheck_text").html('Something went wrong');
            }
        });
    }, "1000");
}
